// extracted by mini-css-extract-plugin
export default {"items":"styles_items__L51la","buttonsWrapper":"styles_buttonsWrapper__IpXPj","taxesNote":"styles_taxesNote__TAeud","loader":"styles_loader__rak5Y"};